import classNames from 'classnames';
import PropTypes from 'prop-types';

const ResetAudienceIcon = ({ className }) => {
  return (
    <svg
      className={classNames('reset-audience-icon', className)}
      width='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.41411 2.77039C4.50973 1.82305 5.93794 1.25 7.5 1.25C10.9518 1.25 13.75 4.04822 13.75 7.5C13.75 8.83506 13.3314 10.0724 12.6183 11.0879L10.625 7.5H12.5C12.5 4.73858 10.2614 2.5 7.5 2.5C6.15614 2.5 4.93611 3.03017 4.03764 3.89276L3.41411 2.77039ZM11.5859 12.2296C10.4903 13.1769 9.06206 13.75 7.5 13.75C4.04822 13.75 1.25 10.9518 1.25 7.5C1.25 6.16491 1.66862 4.9276 2.38175 3.91215L4.375 7.5H2.5C2.5 10.2614 4.73858 12.5 7.5 12.5C8.84388 12.5 10.0639 11.9698 10.9624 11.1073L11.5859 12.2296Z'
        fill='#1B4332'
      />
    </svg>
  );
};

ResetAudienceIcon.propTypes = {
  className: PropTypes.string,
};

export default ResetAudienceIcon;
